<script>
import { defineComponent, inject } from 'vue';
import { ConfigProvider } from 'ant-design-vue';

export default defineComponent({
  components: {
    AConfigProvider: ConfigProvider
  },
  setup() {
    const antLocale = inject('antLocale');
    return {
      antLocale
    };
  }
});
</script>

<template>
  <a-config-provider :locale="antLocale">
    <router-view></router-view>
  </a-config-provider>
</template>

<style scoped></style>
